'use client';

import type { ButtonHTMLAttributes, ReactNode } from 'react';

type StepperSymbol = '−' | '+';

type StepperIconButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  symbol: StepperSymbol;
  srLabel: string;
  children?: ReactNode;
};

/** Sadece ± sembolü görünen sayaçlar — Lighthouse label-content-name-mismatch önler. */
export default function StepperIconButton({
  symbol,
  srLabel,
  className,
  type = 'button',
  ...rest
}: StepperIconButtonProps) {
  return (
    <button type={type} className={className} {...rest}>
      <span className="sr-only">{srLabel}</span>
      <span aria-hidden="true">{symbol}</span>
    </button>
  );
}
